import { TResponse } from '@r1-frontend/do-request/core/types';
import { captureQueryError } from '@r1-frontend/do-request/error';

import contentRequest from '~/src/api/requests/contentRequest';

interface IQuiz {
    alias: string,
    bg_color: string,
    button_text: string,
    created_at: string,
    experiment_id: string,
    id: number,
    image: string,
    is_active: number,
    link: string,
    page_id: number | null,
    parent_id: number | null,
    subtitle: string,
    text_color: string,
    title: string,
    title_ad: string,
    updated_at: string,
}

interface IMeta {
    totalCount: number,
    pageCount: number,
    currentPage: number,
    perPage: number,
}

interface IContent {
    _links: unknown,
    _meta: IMeta,
    items: IQuiz[],
}

export type TDataResponse = TResponse<{items: IContent[]}, any>;

export const getContentBlock = async(providerId: number, alias: string): Promise<TDataResponse> => {
    const url = `v1/content-block?filter[alias]=${alias}&providerId=${providerId}`;

    try {
        const response = await contentRequest.get(url);

        return {
            isSuccess: true,
            payload: response.data,
        };
    } catch (error) {
        return captureQueryError(error);
    }
};
